export const openSaveToBoardModal = (params: {
  imageUrl: string;
  fileName?: string;
  onSuccessAnalyticsEvents?: object[];
}) => {
  const {
    imageUrl,
    fileName = 'Inspiration',
    onSuccessAnalyticsEvents,
  } = params;

  urlToBase64(imageUrl, (base64: string) => {
    window.dispatchEvent(
      new CustomEvent('open-save-to-board-modal', {
        detail: {
          itemsData: [
            {
              type: 'image',
              file_name: fileName,
              base64,
            },
          ],
          // Leaving the "itemIds" for now for backward compatibility
          itemIds: [
            {
              file_name: fileName,
              base64,
            },
          ],
          onSuccessAnalyticsEvents,
        },
      }),
    );
  });
};

const urlToBase64 = (
  src: string,
  callback: (base64: string | null) => void,
) => {
  try {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      // TODO: refactor without type assertion, or add comment
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      const dataURL = canvas.toDataURL('image/jpeg', 0.65);
      canvas.height = img.naturalHeight;
      canvas.width = img.naturalWidth;
      ctx?.drawImage(img, 0, 0);
      callback(dataURL);
    };
    img.src = src;
    if (img.complete || img.complete === undefined) {
      img.src =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      img.src = src;
    }
  } catch (error) {
    callback(null);
    console.error(error);
  }
};

export const goToLogin = () =>
  (window.location.href =
    '/customer/account/login/' +
    `?callbackUrl=${encodeURIComponent(
      window.location.pathname + window.location.hash,
    )}`);
